import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import { useEffect, useState } from "react";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

const LatitudeInput = ({ value, onChange, precision, disabled }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const onLatitudeChange = (event) => {
        const rawInput = event.target.value;
        setInputValue(rawInput);
        onChange(rawInput);
    };

    const onBlur = () => {
        const trimmedInput = inputValue.trim();

        if (!trimmedInput) {
            return;
        }

        const parsedLat = parseFloat(trimmedInput);
        if (isFinite(parsedLat) && !isNaN(parsedLat) && parsedLat >= -90 && parsedLat <= 90) {
            const formattedValue = parsedLat.toFixed(precision);
            setInputValue(formattedValue);
            onChange(formattedValue);
        }
    };

    return <Input value={inputValue} onChange={onLatitudeChange} onBlur={onBlur} placeholder={`Enter latitude (e.g., 40.7128)`} disabled={disabled} />;
};

function FormLatitudeField({ fieldErrors, fieldId, name, description, isRequired, precision, disabled = false, isPII, ...field }) {
    const validateLatitude = (_, value) => {
        if (!value || !value.trim()) {
            return Promise.resolve();
        }

        const trimmedValue = value.trim();
        const parsedLat = parseFloat(trimmedValue);

        if (isNaN(parsedLat)) {
            return Promise.reject("Latitude must be a numeric value");
        }

        if (parsedLat < -90 || parsedLat > 90) {
            return Promise.reject("Latitude must be between -90 and 90 degrees");
        }

        return Promise.resolve();
    };

    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={[]} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {disabled && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            rules={[
                {
                    required: isRequired,
                    message: "Latitude is required",
                },
                {
                    validator: validateLatitude,
                },
            ]}
            {...fieldErrors}
        >
            <LatitudeInput precision={precision} disabled={disabled || isPII} />
        </Form.Item>
    );
}

export default FormLatitudeField;
